import { useEffect, useRef, useState } from "react";

let activeAudio = null;
let activeStop = null;

export default function AudioPreviewButton({ hash, stationID, title = "zvuk", className = "audio-preview-button" }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => () => {
    const audio = audioRef.current;
    if (audio && activeAudio === audio) {
      audio.pause();
      activeAudio = null;
      activeStop = null;
    }
  }, []);

  function stop() {
    const audio = audioRef.current;
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
    if (activeAudio === audio) {
      activeAudio = null;
      activeStop = null;
    }
    setPlaying(false);
  }

  async function toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!hash) return;
    if (playing) return stop();
    activeStop?.();
    const audio = audioRef.current ?? new Audio();
    audioRef.current = audio;
    audio.src = `/api/v1/media/${hash}${stationID ? `?stationID=${encodeURIComponent(stationID)}` : ""}`;
    audio.preload = "metadata";
    audio.onended = stop;
    audio.onerror = stop;
    activeAudio = audio;
    activeStop = stop;
    setPlaying(true);
    try { await audio.play(); }
    catch { stop(); }
  }

  return <button
    type="button"
    className={`${className}${playing ? " playing" : ""}`}
    disabled={!hash}
    aria-label={playing ? `Zastavit ukázku ${title}` : `Přehrát ukázku ${title}`}
    title={playing ? "Zastavit ukázku" : "Přehrát ukázku"}
    onClick={toggle}
  >{playing ? "■" : "▶"}</button>;
}
